import Vue from 'vue';
import VueApollo from 'vue-apollo';
import Vuelidate from 'vuelidate';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';

import apolloClient from '@/services/apollo';
import App from './App.vue';
import router from './router';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;
Vue.use(VueApollo);
Vue.use(Vuelidate);
Vue.use(VueMoment, {
  moment,
});
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

// Add a universal router-link directive so you can use it as an attribute
Vue.directive('router-link', {
  inserted(el, binding, vnode) {
    el.addEventListener('click', () => {
      vnode.context.$router.push(binding.value);
    });
  },
});

new Vue({
  apolloProvider,
  router,
  render: (h) => h(App),
}).$mount('#app');

Sentry.init({
  dsn: 'https://2f1b0f2496b1447895328444ed8e195b@o371444.ingest.sentry.io/5464478',
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
      logErrors: true,
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});
